<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Mrs. Adams in Winter</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="para"> </p>
<p class="imaget"><a id="page_x"></a><a id="frontmatter02"></a><a id="fig02"></a><img alt="Images" src="images/f000x-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?2949f137